exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".articleAbstract,.articleTitle,.articleType{width:80%}.articleAuthor{width:100%}.articleContent{width:98%}.containVideo{position:absolute;top:20px;left:450px}.ql-container{min-height:400px}#canvas{width:200px!important;height:200px!important}.ql-video{width:300px;height:86px}.gray{color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-51f84e94!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/about/about.vue
// module id = 533
// module chunks = 0